import React from 'react';
import { useGetAllProjectSections } from '@/features/projects/hooks/useGetAllProjectSections';
import { useGetAllTasksByProject } from '@/features/projects/hooks/tasks/useGetAllTasksByProject';

interface TasksDebugInfoProps {
  projectId: string;
}

export const TasksDebugInfo: React.FC<TasksDebugInfoProps> = ({ projectId }) => {
  const { data: sections, isSuccess: isSectionsSuccess, isPending: isSectionsPending, error: sectionsError } = useGetAllProjectSections(Number(projectId));
  const { data: tasksData, isSuccess: isTasksSuccess, isPending: isTasksPending, error: tasksError } = useGetAllTasksByProject({
    enabled: !!projectId,
    projectId: projectId,
  });

  const [isMinimized, setIsMinimized] = React.useState(false);

  if (isMinimized) {
    return (
      <div style={{ 
        position: 'fixed', 
        top: '10px', 
        right: '10px', 
        background: 'white', 
        border: '1px solid #ccc', 
        padding: '5px', 
        zIndex: 9999,
        fontSize: '12px',
        cursor: 'pointer'
      }} onClick={() => setIsMinimized(false)}>
        🐛 Debug (click to expand)
      </div>
    );
  }

  return (
    <div style={{ 
      position: 'fixed', 
      top: '10px', 
      right: '10px', 
      background: 'white', 
      border: '1px solid #ccc', 
      padding: '10px', 
      zIndex: 9999,
      maxWidth: '400px',
      maxHeight: '500px',
      overflow: 'auto',
      fontSize: '12px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>🐛 Debug - Project {projectId}</h3>
        <button onClick={() => setIsMinimized(true)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
          ➖
        </button>
      </div>
      
      <div style={{ marginBottom: '15px' }}>
        <h4 style={{ color: isSectionsSuccess ? 'green' : sectionsError ? 'red' : 'orange' }}>
          📁 Sections: {isSectionsPending ? '⏳' : isSectionsSuccess ? '✅' : '❌'}
        </h4>
        <p><strong>Loading:</strong> {isSectionsPending ? 'Yes' : 'No'}</p>
        <p><strong>Success:</strong> {isSectionsSuccess ? 'Yes' : 'No'}</p>
        <p><strong>Error:</strong> {sectionsError ? (sectionsError as Error).message || 'Unknown error' : 'None'}</p>
        <p><strong>Count:</strong> {sections?.data?.length || 0}</p>
        {sections?.data && (
          <details>
            <summary>View Data</summary>
            <pre style={{ fontSize: '10px', maxHeight: '100px', overflow: 'auto' }}>
              {JSON.stringify(sections.data, null, 2)}
            </pre>
          </details>
        )}
      </div>

      <div>
        <h4 style={{ color: isTasksSuccess ? 'green' : tasksError ? 'red' : 'orange' }}>
          📋 Tasks: {isTasksPending ? '⏳' : isTasksSuccess ? '✅' : '❌'}
        </h4>
        <p><strong>Loading:</strong> {isTasksPending ? 'Yes' : 'No'}</p>
        <p><strong>Success:</strong> {isTasksSuccess ? 'Yes' : 'No'}</p>
        <p><strong>Error:</strong> {tasksError ? (tasksError as Error).message || 'Unknown error' : 'None'}</p>
        <p><strong>Count:</strong> {tasksData?.data?.length || 0}</p>
        {tasksData?.data && (
          <details>
            <summary>View Data</summary>
            <pre style={{ fontSize: '10px', maxHeight: '100px', overflow: 'auto' }}>
              {JSON.stringify(tasksData.data, null, 2)}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
};